import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";
import {
  StyledTableRow,
  StyledTableCell,
} from "app/main/apps/common/AuraFunctions";
import { Icon } from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";

function ContainerHeader(props) {
  const { data, param, orderWeight } = props;

  return (
    <Box boxShadow={2} >
      {/* <div className="flex flex-wrap w-full items-center px-8 py-4 md:px-16 border-b"> */}
      <StyledTableRow className="flex flex-wrap w-full items-center border-b">
        <StyledTableCell align="left" className="w-1/2 flex flex-row">
          {param?.shipToLocation && (
            <div className="flex items-center justify-center opacity-75">
              <Icon fontSize="small">location_on</Icon>
              <div className="text-14 font-medium whitespace-nowrap ml-4 ">
                {param?.shipToLocation ? param?.shipToLocation : ""}
              </div>
            </div>
          )}
          <div className="flex items-center justify-center opacity-75 px-20">
            <Typography className="font-bold truncate ml-8 mr-4" color="inherit">
              Order: #
            </Typography>
            <div className="text-14 font-medium whitespace-nowrap">
              {data?.order_no ? data?.order_no : ""}
            </div>
          </div>
          <div className="flex items-center justify-center opacity-75 px-15">
            <Typography className="font-bold truncate mx-8" color="inherit">
              Order Weight :
            </Typography>
            <div className="text-14 font-medium whitespace-nowrap">
              {orderWeight || 0} lbs
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell align="right" className="w-1/2 flex" style={{ color: "rgb(45, 105, 48)" }}>
          {/* <Typography className="font-medium truncate mx-8" color="inherit">
            Total Weight : {(param?.otherOrdersWeight || 0) + (orderWeight || 0)} lbs
          </Typography> */}
          <div className="flex items-center justify-center opacity-75">
            <FuseSvgIcon className="text-48 green" size={24} color="action">
              feather:package
            </FuseSvgIcon>
            <Typography className="font-medium truncate mx-8" color="inherit">
              Total Weight
            </Typography>
            <div className="text-14 font-medium whitespace-nowrap">
              {(param?.otherOrdersWeight || 0) + (orderWeight || 0)} lbs
            </div>
          </div>
        </StyledTableCell>
      </StyledTableRow>
    </Box>
  );
}

export default ContainerHeader;
